import React from "react";
import {Typography} from "@mui/material";

export const OpportunityRankPopoverText: React.FC = () => {
    return <Typography sx={{maxWidth: '32em', p: 1}} variant="body1">
        <b>Opportunity rank</b> measures how spread a category’s spend is across suppliers and data sets.
        Scores run from <b>0 (low)</b> to <b>4 (high)</b>.
        The higher the number, the bigger the consolidation opportunity.
    </Typography>
}
